import haldi_logo from "../images/haldi/haldi_logo.png";
import '../invitations/Invitation.css'

const haldiInvitationElements = [

  // TEXT CONTENT

  {
    id: 11,
    type: "text",
    text: "💜 Haldi Ceremony 💜",
    x: 24,
    y: 200,
    fontSize: 60,
    fontFamily: "Dancing Script",
    fill: "#4B0082"
  },
  {
    id: 12,
    type: "text",
    text: "With joyful hearts, we invite you to",
    x: 130,
    y: 70,
    fontSize: 26,
    fontFamily: "Dancing Script",
    fill: "#4B0082"
  },
  {
    id: 13,
    type: "text",
    text: "celebrate the Haldi ceremony of",
    x: 140,
    y: 100,
    fontSize: 26,
    fontFamily: "Dancing Script",
    fill: "#4B0082"
  },
  {
    id: 14,
    type: "text",
    text: "Bride/Groom Name 💜",
    x: 130,
    y: 140,
    fontSize: 32,
    fontFamily: "Raleway",
    fill: "#4B0082"
  },
  {
    id: 15,
    type: "text",
    text: "🗓️Date: Sunday, 22/03/2026",
    x: 170,
    y: 370,
    fontSize: 22,
    fontFamily: "Cardo",
    fill: "#4B0082"
  },
  {
    id: 16,
    type: "text",
    text: "⏱️ Time: 10:00 AM onwards",
    x: 170,
    y: 400,
    fontSize: 22,
    fontFamily: "Cardo",
    fill: "#4B0082"
  },
  {
    id: 17,
    type: "text",
    text: "📍 Venue:",
    x: 210,
    y: 500,
    fontSize: 30,
    fontFamily: "Josefin Sans",
    fill: "#4B0082"
  },
  {
    id: 18,
    type: "text",
    text: "Green Garden Function Hall",
    x: 170,
    y: 530,
    fontSize: 20,
    fontFamily: "Josefin Sans",
    fill: "#4B0082"
  },
  {
    id: 19,
    type: "text",
    text: "Guntur",
    x: 170,
    y: 560,
    fontSize: 20,
    fontFamily: "Josefin Sans",
    fill: "#4B0082"
  },
  {
    id: 20,
    type: "text",
    text: "Join us for turmeric, laughter & blessings 🌼",
    x: 80,
    y: 640,
    fontSize: 30,
    fontFamily: "Dancing Script",
    fill: "#4B0082"
  },
  {
    id: 21,
    type: "text",
    text: "Dress Code: Yellow 💛",
    x: 160,
    y: 700,
    fontSize: 30,
    fontFamily: "Great Vibes",
    fill: "#4B0082"
  },
  {
    id: 22,
    type: "text",
    text: "📱 Contact: 98765xxxxx",
    x: 280,
    y: 770,
    fontSize: 30,
    fontFamily: "Great Vibes",
    fill: "#4B0082"
  },
  {
  id: 23,
  type: "background",
  src: haldi_logo,
  x: 0,
  y: 0,
  width: 595,
  height: 842
}

];

export default haldiInvitationElements;